export const InkleTalksIcon = ({ color = "#784EFF" }: { color?: string }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="YoutubeLogo" clipPath="url(#clip0_110_16601)">
        <path
          id="Vector"
          opacity="0.2"
          d="M21.9284 6.72165C21.8706 6.49039 21.7586 6.27622 21.6016 6.09688C21.4446 5.91754 21.2471 5.7782 21.0255 5.6904C17.8868 4.4829 12.6855 4.51571 12.6855 4.51571C12.6855 4.51571 7.4843 4.4829 4.3418 5.69509C4.1202 5.78289 3.92272 5.92223 3.76572 6.10157C3.60872 6.28091 3.49671 6.49508 3.43898 6.72634C3.22336 7.56634 2.93555 9.21165 2.93555 12.0157C2.93555 14.8198 3.22336 16.4651 3.44273 17.3098C3.50075 17.5398 3.61248 17.7528 3.76877 17.9312C3.92506 18.1097 4.12144 18.2485 4.3418 18.3363C7.4843 19.5485 12.6855 19.5157 12.6855 19.5157C12.6855 19.5157 17.8868 19.5485 21.0293 18.3363C21.2504 18.249 21.4475 18.1104 21.6044 17.9319C21.7614 17.7534 21.8737 17.5402 21.9321 17.3098C22.1515 16.466 22.4393 14.8198 22.4393 12.0157C22.4393 9.21165 22.1477 7.56634 21.9284 6.72165ZM11.1855 15.0157V9.01571L15.6855 12.0157L11.1855 15.0157Z"
          fill={color}
        />
        <path
          id="Vector_2"
          d="M15.6855 12.0157L11.1855 9.01569V15.0157L15.6855 12.0157Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M2.93555 12.0157C2.93555 14.8198 3.22336 16.4641 3.44273 17.3098C3.50075 17.5398 3.61248 17.7528 3.76877 17.9312C3.92506 18.1097 4.12144 18.2485 4.3418 18.3363C7.4843 19.5485 12.6855 19.5157 12.6855 19.5157C12.6855 19.5157 17.8868 19.5485 21.0293 18.3363C21.2504 18.249 21.4475 18.1104 21.6044 17.9319C21.7614 17.7534 21.8737 17.5402 21.9321 17.3098C22.1515 16.466 22.4393 14.8198 22.4393 12.0157C22.4393 9.21165 22.1515 7.56727 21.9321 6.72165C21.8744 6.49039 21.7624 6.27622 21.6054 6.09688C21.4484 5.91754 21.2509 5.7782 21.0293 5.6904C17.8868 4.4829 12.6855 4.51571 12.6855 4.51571C12.6855 4.51571 7.4843 4.4829 4.3418 5.69509C4.1202 5.78289 3.92272 5.92223 3.76572 6.10157C3.60872 6.28091 3.49671 6.49508 3.43898 6.72634C3.22336 7.56634 2.93555 9.21165 2.93555 12.0157Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_110_16601">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.685547 0.015686)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
